import { render, staticRenderFns } from "./property-table.vue?vue&type=template&id=05955e98"
import script from "./property-table.vue?vue&type=script&lang=js"
export * from "./property-table.vue?vue&type=script&lang=js"
import style0 from "./property-table.vue?vue&type=style&index=0&id=05955e98&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports